<template>
  <ExtendedDialog
    :show-dialog="show"
    :config="unlicensedDialog"
    leftImageSource="assets/upselling/expiring.svg"
    @execute-action="execute($event)"
  >
    <div class="px-8 pb-4">
      <p>{{ $t('upselling.expiredTrialText') }}</p>
    </div>
  </ExtendedDialog>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { ButtonCallbacks } from '@/components/types/Dialog';
import { unlicensedDialog } from '@/models/upselling/upsellingDialogConfig';

export default defineComponent({
  name: 'UnlicensedDialog',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  emits: ['closeDialog'],
  data() {
    return {
      unlicensedDialog
    };
  },

  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.$emit('closeDialog', value);
      }
    }
  },
  methods: {
    async execute(callback: ButtonCallbacks) {
      if (callback === ButtonCallbacks.ACTION) {
        await this.$router.push('/plan-overview');
      }
      this.show = false;
    }
  }
});
</script>
